export default {
  light: {
    primary: '#4F55A7',
    secondary: '#828282',
    error: '#FF4081',
    warning: '#FFC260',
    success: '#3CD4A0',
    info: '#9013FE',
    textColor: '#B9B9B9',
    iconColor: '#FFFFFF59',
    grayBold: '#4a4a4a'
  }
}
